export default "__VITE_ASSET__CV3LvmBr__"